import { useAppTranslation, useBackToShop } from "@/utils";
import { CloseCircleFilled } from "@payping/icons";
import { Button, Flex, Typography } from "@payping/web-components";

interface PayExpiredOrderProps {
  shopName?: string;
  backToShop?: () => void;
}
const PayExpiredOrder = (props: PayExpiredOrderProps) => {
  const { t } = useAppTranslation();

  const { backToShop, shopName } = useBackToShop();
  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!" gap={"middle"} align="center">
      <Flex vertical align="center" gap={"large"} className="tw:my-auto tw:w-full">
        <CloseCircleFilled width={80} className="tw:fill-color-error" />
        <Flex vertical gap={"small"} align="center" className="tw:mt-1!">
          <Typography.Title level={5} className="tw:m-0! tw:text-center!">
            {t("pay.expiredOrderTitle")}
          </Typography.Title>
          <Typography.Paragraph type="secondary" className="tw:m-0!">
            {t("pay.expiredOrderContent")}
          </Typography.Paragraph>
        </Flex>
      </Flex>

      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        <Button
          block
          onClick={() => {
            if (props.backToShop) {
              backToShop();
            } else {
              backToShop();
            }
          }}
        >
          {props.shopName || shopName
            ? t("common.returnTo", { name: props.shopName ?? shopName })
            : t("common.returnToShop")}
        </Button>
      </Flex>
    </Flex>
  );
};

export default PayExpiredOrder;
